import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CityIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M9 6a1 1 0 0 0 0 2h1a1 1 0 1 0 0-2H9Zm-1 5c0-.6.4-1 1-1h1a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm6-5a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1Zm-1 5c0-.6.4-1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z" />
    <path
      fillRule="evenodd"
      d="M5 3.5C5 2.1 6.1 1 7.5 1h9C17.9 1 19 2.1 19 3.5V8h1.5c1.4 0 2.5 1.1 2.5 2.5V22c0 .6-.4 1-1 1H1.9a1 1 0 0 1-.9-1v-8.5C1 12.1 2.1 11 3.5 11H5V3.5ZM3 21h2v-8H3.5c-.3 0-.5.2-.5.5V21Zm18-10.5V21h-2V10h1.5c.3 0 .5.2.5.5ZM9 21v-5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v5h2V3.5c0-.3-.2-.5-.5-.5h-9c-.3 0-.5.2-.5.5V21h2Zm4 0v-5h-2v5h2Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default CityIcon;
